export default __webpack_public_path__ + "static/media/users_openapi.e1fa6559.yaml";